<template>
  <div class="card mx-3 mt-3 mb-3">
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-motorcycle me-2 text-primary" />
          {{ $t('_delivery.Delivery Channels') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ is_enabled ? $t('_delivery.Delivery platform enabled') : $t('_delivery.Delivery platform disabled - Platform Orders menu is hidden on POS') }}
        </div>
        <router-link
          v-if="is_enabled"
          to="/delivery-platforms"
          class="d-inline-block mt-1"
          style="font-size: 13px;"
        >
          {{ $t('_delivery.Manage channels, GP and platform prices') }}
          <i class="fa-solid fa-chevron-right ms-1" style="font-size: 11px;" />
        </router-link>
      </div>
      <div class="form-check form-switch m-0">
        <input
          id="deliveryPlatformEnabledSwitch"
          class="form-check-input"
          type="checkbox"
          role="switch"
          style="width: 3rem; height: 1.5rem;"
          :checked="is_enabled"
          :disabled="saving"
          @change="onToggle($event.target.checked)"
        >
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { Setting } from '@/services/endpoint/setting.service';

export default {
  name: 'DeliveryPlatformsSettingsCard',
  // ค่าเริ่มต้นมาจากหน้า settings (GET ครั้งเดียว) — card ทำหน้าที่ PUT toggle เท่านั้น (mirror PromotionSettingsCard)
  // ปิด = ซ่อนเมนู "ออเดอร์ Platform" บน POS (มีผลรอบถัดไปที่ POS เข้าร้าน/refresh)
  props: {
    initialEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_enabled: this.initialEnabled,
      saving: false
    };
  },
  methods: {
    async onToggle(value) {
      const prev = this.is_enabled;
      this.is_enabled = value; // optimistic — UI flips ทันที
      this.saving = true;
      try {
        await Setting.update({ delivery_platform_is_enabled: value ? 1 : 0 });
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('_delivery.Delivery platform settings updated'));
      } catch (err) {
        this.is_enabled = prev; // revert (เช่นกรณีไม่มีสิทธิ์ setting_manage)
        this.$toast.warn(this.$t(err?.response?.data?.message) || this.$t('Failed to update settings'));
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
